<script lang="ts">
  import { scale } from 'svelte/transition';
  import { Select } from 'bits-ui';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  import Sort from '$lib/icons/iconsax/outline/Sort.svelte';
  import Tick from '$lib/icons/iconsax/outline/Tick.svelte';

  const dispatch = createEventDispatcher<{
    itemSelected: { item: any };
  }>();

  export let selected: any;
  export let items = [];

  let handleSelectedChange = newItem => {
    dispatch('itemSelected', { item: newItem.value });
  };
</script>

<Select.Root {items} onSelectedChange={e => handleSelectedChange(e)} bind:selected>
  <Select.Trigger
    class=" relative rounded-9px border px-[11px] text-sm rounded-xl"
    aria-label="Select "
  >
    <Sort />
  </Select.Trigger>
  <Select.Content
    class="flex flex-col
    !min-w-[200px] border border-garden-grey-200
    rounded-10 bg-white gap-1 p-2"
    transition={scale}
    transitionConfig={{ duration: 120, start: 0.9 }}
    sideOffset={8}
  >
    {#each items as choice}
      <Select.Item
        class="whitespace-nowrap block p-4 text-garden-grey-700 font-switzer font-medium hover:bg-garden-grey-100 transition-all cursor-pointer"
        label={choice.data.label}
        value={choice}
      >
        <span class="flex flex-row gap-2">
          {choice.data.label}
          <Select.ItemIndicator class="" asChild={false}>
            <Tick size={24} />
          </Select.ItemIndicator>
        </span>
      </Select.Item>
    {/each}
  </Select.Content>
  <Select.Input name="sort" />
</Select.Root>
